import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { COM_PORCENTAGEM_MANUAL, ModalidadeGarantia } from '../../model/modalidade_garantia.model';

@Injectable({
    providedIn: 'root'
})
export class ModalidadeService {

    private modalidadeSubject = new BehaviorSubject<string>(undefined);

    private modalidades: ModalidadeGarantia[] = [];

    public modalidade$ = this.modalidadeSubject.asObservable().pipe(
        filter(modalidade => modalidade !== undefined),
    );

    public modalidadeTitulo$ = this.modalidade$.pipe(
    map(m => {
        const found = this.getModalidades().find(m0 => m0.sigla === m);
        return found ? found.nome : 'FG2';
    }));

    public modalidadeTipoConglomeradoManual$ = this.modalidade$.pipe(
      map(m => {
          const found = this.getModalidades().find(m0 => m0.sigla === m);
          return found ? found.idTipoConglomerado === COM_PORCENTAGEM_MANUAL : null;
      }));

    //Criado para solucionar o problema da lista vazia Escolha Modalidade pagina recarregada
    private modalidadesAssincronoSubject = new BehaviorSubject<ModalidadeGarantia[]>([]);
    private modalidades$: Observable<ModalidadeGarantia[]> = this.modalidadesAssincronoSubject.asObservable();

    constructor() {} //não pode ter nada que usa HTTP neste construtor ou o interceptor para de funcionar (dep cíclica)

    public getModalidades(): ModalidadeGarantia[] {
        return this.modalidades;
      }

      public setModalidades(m: ModalidadeGarantia[]) {
        this.modalidades = m;
      }

    public escolherModalidade(modalidade) {
        this.modalidadeSubject.next(modalidade);
    }

    public getModalidadesAssincrono(): Observable<ModalidadeGarantia[]> {
        return this.modalidades$
    }
    public setModalidadesAssincrono(m: ModalidadeGarantia[]) {
        return this.modalidadesAssincronoSubject.next(m);
    }
}
